module.exports = __webpack_public_path__ + "images/pages/vocal-fold/patient-4.png";